import { useState } from 'react';
import { Link } from 'wouter';
import { SEOHead } from '../components/SEOHead';
import { Camera, Upload, Sparkles, ArrowRight } from 'lucide-react';

export default function AppSplashFirstLaunch() {
  const [step, setStep] = useState(0);

  const steps = [
    {
      icon: Camera,
      title: 'Fotografieren',
      description: 'Nutze dein iPhone für professionelle Immobilienfotos',
    },
    {
      icon: Upload,
      title: 'Hochladen',
      description: 'Lade deine Fotos sicher und schnell hoch',
    },
    {
      icon: Sparkles,
      title: 'Bearbeiten lassen',
      description: 'Unser Team bearbeitet deine Bilder professionell',
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#74A4EA] to-[#64BF49] flex flex-col items-center justify-center px-8 text-white">
      <SEOHead title="Willkommen – pixcapture.app" description="Erste Schritte" path="/app/splash-firstlaunch" />
      
      <div className="max-w-md w-full">
        <div className="text-center mb-12">
          {React.createElement(steps[step].icon, { className: "h-20 w-20 mx-auto mb-6" })}
          <h2 className="text-[32px] mb-4">{steps[step].title}</h2>
          <p className="text-white/80 text-[18px]">{steps[step].description}</p>
        </div>

        <div className="flex gap-2 justify-center mb-12">
          {steps.map((_, index) => (
            <div
              key={index}
              className={`h-2 rounded-full transition-all ${
                index === step ? 'w-8 bg-white' : 'w-2 bg-white/40'
              }`}
            />
          ))}
        </div>

        {step < steps.length - 1 ? (
          <button
            onClick={() => setStep(step + 1)}
            className="w-full py-4 bg-white text-[var(--color-accent)] rounded-md flex items-center justify-center gap-2"
          >
            Weiter
            <ArrowRight className="h-5 w-5" />
          </button>
        ) : (
          <Link href="/app/login">
            <button className="w-full py-4 bg-white text-[var(--color-accent)] rounded-md">
              Los geht's
            </button>
          </Link>
        )}
      </div>
    </div>
  );
}
